import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgZelfstandige1 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      d="M20 17a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="M20 17a6 6 0 0 1 6 6v8H14v-8a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M17.017 11.947a3.02 3.02 0 0 0 6.006 0l.994.106a4.02 4.02 0 0 1-7.994 0z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M10.86 22h18.28a.79.79 0 0 1 .78.86L29 32.6a.4.4 0 0 1-.4.37H11.37a.4.4 0 0 1-.4-.37l-.89-9.74a.79.79 0 0 1 .78-.86"
      clipRule="evenodd"
    />
    <path
      fill="#FFBFA5"
      d="M20 29.97a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M10.209 23.5h2.45v1H10.21a.91.91 0 0 0-.903 1l.45 4.45-.995.1-.45-4.45a1.913 1.913 0 0 1 1.897-2.1"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgZelfstandige1);

export default ForwardRef;
